// extracted by mini-css-extract-plugin
export default {"fab":"SendUserRequestFormFab_fab__AHqpv","fabButton":"SendUserRequestFormFab_fabButton__tC1SE"};